import template from './specialty-required.jade';
import validation from '../../../services/validation';

export default angular
  .module('cian.addForm.aboutObjectSpecialtyRequired', ['cian.addForm.helperSpecialty'])
  .directive('cianAfAboutObjectSpecialtyRequired', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller: [
      function () {
        this.validation = validation(this.form, 'specialty', {
          required: 'Обязательное поле',
        });
      },
    ],
    controllerAs: 'specialty',
    template,
  })).name;
